export default __webpack_public_path__ + "static/media/expert03.8d401fb5.jpg";